'use strict';

(() => {
  const status = document.querySelector('[data-or-global-status]');

  document.addEventListener('oluvie:cart-added', (event) => {
    const count = event.detail.cart?.item_count;
    if (!Number.isFinite(count)) return;
    for (const node of document.querySelectorAll('[data-or-cart-count]')) {
      node.textContent = count;
      node.hidden = count < 1;
    }
    if (status) status.textContent = count === 1 ? '1 artikel in winkelwagen.' : `${count} artikelen in winkelwagen.`;
  });
})();
